import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';
import { useResendVerification } from '@/hooks/useResendVerification';

interface EmailNotVerifiedNoticeProps {
  className?: string;
  /** Optional extra action (e.g. "Try again") rendered next to the resend button. */
  children?: React.ReactNode;
}

/** Shown when a purchase route answers 403 EMAIL_NOT_VERIFIED: explains, offers resend, hints at spam. */
export const EmailNotVerifiedNotice = ({ className = '', children }: EmailNotVerifiedNoticeProps) => {
  const { t } = useTranslation('settings');
  const { status, resend } = useResendVerification();
  return (
    <div role="alert" className={className}>
      <p className="font-semibold text-amber-900">{t('shop_email_not_verified')}</p>
      <p className="mt-1 text-sm text-amber-900">{t('shop_email_not_verified_spam')}</p>
      <div className="mt-3 flex flex-wrap items-center gap-3">
        {status === 'sent' ? (
          <span role="status" className="text-sm font-semibold text-emerald-700">{t('shop_email_resend_sent')}</span>
        ) : (
          <Button type="button" variant="outline" size="sm" loading={status === 'sending'} disabled={status === 'sending'} onClick={resend}>
            {status === 'sending' ? t('shop_email_resend_sending') : t('shop_email_resend')}
          </Button>
        )}
        {children}
      </div>
      {status === 'error' && <p className="mt-2 text-sm text-red-700">{t('shop_email_resend_error')}</p>}
    </div>
  );
};
